<script setup lang="ts">
const dialogStore = useDialogStore()
const dialog = dialogStore.name

const gameStateStore = useGameStateStore()
const { user: userInfo } = storeToRefs(gameStateStore)
const { updateUserName } = gameStateStore
const { triggerEventAndProcess } = useEventSystem()

const newName = ref<string>(userInfo.value?.name || '')

// Update name when dialog becomes visible
watch(() => dialog.visible, (visible) => {
  if (visible && userInfo.value) {
    newName.value = userInfo.value.name
    triggerEventAndProcess('ENTER:nameChangeDialog')
  }
  if (!visible) {
    triggerEventAndProcess('LEAVE:nameChangeDialog')
  }
})

const onSubmit = async () => {
  // Save the new name
  await updateUserName(newName.value)

  // Trigger the event for name change
  // triggerEventAndProcess('wld_encodia.clearMyNameIs')

  // Close the dialog
  dialogStore.closeDialog('name', 'submit')
}

const onCancel = () => {
  dialogStore.closeDialog('name', 'cancel')
}
</script>

<template>
  <Dialog
    v-if="dialog.params"
    :title="dialog.params.title || '名前を変える'"
    :model-value="dialog.visible"
    :cancel-button="{ title: dialog.params?.actions?.cancel?.label || 'とじる' }"
    :submit-button="{ title: dialog.params?.actions?.submit?.label || '決定する' }"
    @submit="onSubmit"
    @cancel="onCancel"
  >
    <template #default>
      <v-container class="align-center w-75">
        <v-text-field
          v-model="newName"
          label=""
          class="name-edit"
        />
      </v-container>
    </template>
  </Dialog>
</template>

<style scoped>
.name-edit * {
  /* font-size: 3rem; */
  font-size: 130%;
}
</style>
